import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

export const getVendors = async () => {
  try {
    return await axiosInstance.get(API_ENDPOINTS.VENDORS);
  } catch (error) {
    throw error;
  }
};

export const getVendorById = async (id) => {
  try {
    return await axiosInstance.get(API_ENDPOINTS.GET_VENDOR_BY_ID(id));
  } catch (error) {
    throw error;
  }
};

export const getVendorShareDetails = async (id) => {
  try {
    return await axiosInstance.get(API_ENDPOINTS.GET_VENDOR_SHARE_DETAILS(id));
  } catch (error) {
    throw error;
  }
};

export default {
  getVendors,
  getVendorById,
  getVendorShareDetails,
};
